import React from 'react';
import { MapProvider } from '@app/configs/map';
import GoogleMap from './GoogleMap';

interface LocationChoice {
  ref_id: string;
  display: string;
}

interface MapProps {
  onMapLoad?: (map: any) => void;
  searchQuery?: string;
  onLocationSelect?: (location: any) => void;
  onCurrentLocationFound?: (location: any) => void;
  className?: string;
  mapProvider?: MapProvider;
  // Directions props for Google Maps
  origin?: { lat: number; lng: number } | string;
  destination?: { lat: number; lng: number } | string;
  autocompleteSearch?: string;
  travelMode?: google.maps.TravelMode | 'DRIVING' | 'WALKING' | 'BICYCLING' | 'TRANSIT';
  onRouteCalculated?: (route: google.maps.DirectionsResult) => void;
  // Location choices props
  locationChoices?: LocationChoice[];
  onLocationChoiceSelect?: (choice: LocationChoice) => void;
}

const Map: React.FC<MapProps> = ({
  onMapLoad,
  searchQuery,
  onLocationSelect,
  onCurrentLocationFound,
  className,
  origin,
  destination,
  autocompleteSearch,
  travelMode,
  onRouteCalculated,
  locationChoices,
  onLocationChoiceSelect,
}) => {
  return (
    <GoogleMap
      onMapLoad={onMapLoad}
      searchQuery={searchQuery}
      onLocationSelect={onLocationSelect}
      onCurrentLocationFound={onCurrentLocationFound}
      className={className}
      origin={origin}
      destination={destination}
      autocompleteSearch={autocompleteSearch}
      travelMode={travelMode}
      onRouteCalculated={onRouteCalculated}
      locationChoices={locationChoices}
      onLocationChoiceSelect={onLocationChoiceSelect}
    />
  );
};

export { Map };
